/**
 * Models for the Station Assignment page
 */

/**
 * Get current date in YYYY-MM-DD format (for API requests)
 */
export function getTodayDate(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
